export class LayoutConstant
{
    public static readonly assets = '/assets/';
    public static readonly blank = '_blank';
    public static readonly self = '_self';
}